import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "@/lib/api";

export function useIsSubscribed(writerId: string, subscriberAddress: string) {
  return useQuery({
    queryKey: ["subscription", writerId, subscriberAddress],
    queryFn: () => api.isSubscribed(writerId, subscriberAddress),
    enabled: !!writerId && !!subscriberAddress,
  });
}

export function useSubscribe() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { writerId: string; subscriberAddress: string }) =>
      api.subscribe(data.writerId, data.subscriberAddress),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["subscription", variables.writerId],
      });
      queryClient.invalidateQueries({
        queryKey: ["writerProfile", variables.writerId],
      });
    },
  });
}

export function useUnsubscribe() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { writerId: string; subscriberAddress: string }) =>
      api.unsubscribe(data.writerId, data.subscriberAddress),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["subscription", variables.writerId],
      });
      queryClient.invalidateQueries({
        queryKey: ["writerProfile", variables.writerId],
      });
    },
  });
}
